<template>
  <div style="height:100%;background: #1cc0ff;">
    <div class="downloadapp" v-if="isHidden">
      <div class="head">
        <span>一起快乐学英语</span>
      </div>
      <div class="content">
        <div class="content-head dz-flex">
          <span class="left-photo">
            <img src="../../assets/img/download/down06.png" alt="">
          </span>
          <span class="english">HAPPY LEARNING</span>
        </div>
        <div class="content-center">
          <div class="center-head">
            <img class="img-left" src="../../assets/img/download/down02.png" alt="">
            <img class="img-right" src="../../assets/img/download/down03.png" alt="">
          </div>
          <div class="center-box">
            <div class="soild-box">
              <div class="content-one dz-flex-center">
                <div class="small"></div>
                <div class="big"></div>
                <el-button>下载地址</el-button>
                <div class="big"></div>
                <div class="small"></div>
              </div>
              <div class="content-two dz-flex-center">
                <img src="../../assets/img/download/down07.png" alt="">
                <span>教材名称：{{bookName}}</span>
              </div>
              <div class="content-three dz-flex-center">
                <div class="btn dz-flex dz-flex-align-center" @click="downloadApp">
                  <div class="white-circle">
                    <img src="../../assets/img/download/down05.png" alt="">
                  </div>
                  <div>
                    <span class="content-text">Android版下载</span>
                  </div>
                </div>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="last-photo">
        <img class="img-one" src="../../assets/img/download/down09.png" alt="">
        <img class="img-two" src="../../assets/img/download/down08.png" alt="">
        <img class="img-three" src="../../assets/img/download/down11.png" alt="">
      </div>
    </div>
    <div class="wxtip" id="JweixinTip">
    </div>
  </div>
</template>

<script>
import { $verifyDownloadCode } from '@/api/code';
import { $debounce } from '@/utils/index';
export default {
  data() {
    return {
      isHidden: false,
      isWeiXin: '',
      isAndroid: '',
      code: '',
      bookName: '',
    };
  },
  beforeCreate() {
// 在 Vue 生命周期钩子里（如 mounted）调用
    this.$nextTick(() => {
      /* ---------- 1. 解析 # 后面的查询参数 ---------- */
      // location.hash 可能是 "#/downloadapp?code=a5vLEeuH2V&bookName=EFL%20Phonics%203rd"
      const hash      = window.location.hash || '';
      const idxQuery  = hash.indexOf('?');            // 找到 '?' 在 hash 中的位置
      const rawSearch = idxQuery > -1 ? hash.slice(idxQuery + 1) : '';
      const search    = new URLSearchParams(rawSearch); // 用 URLSearchParams 解析 query

      const rawBookName = search.get('bookName') || ''; // "EFL%20Phonics%203rd"
      const rawCode     = search.get('code')     || ''; // "a5vLEeuH2V"

      /* ---------- 2. 去掉 URL 转义 ---------- */
      this.bookName = decodeURIComponent(rawBookName);  // "EFL Phonics 3rd"
      this.code     = decodeURIComponent(rawCode);      // "a5vLEeuH2V"

      /* ---------- 3. 判断是否在微信内置浏览器 ---------- */
      this.isWeiXin = /micromessenger/i.test(navigator.userAgent);

      if (this.isWeiXin) {
        const tipEl = document.getElementById('JweixinTip');
        if (tipEl) tipEl.style.display = 'block';      // 在微信里显示引导层
      } else {
        this.isHidden = true;                          // 非微信直接展示主内容
      }
    });
  },
  methods: {
    // 下载app
    downloadApp: $debounce(async function () {
      // 截取地址 获取code
      // let code = window.location.href.substring(window.location.href.indexOf('=') + 1);
      let pro = this.$http({
        url: '/edu/downloadCode/verifyDownloadCode?code=' + this.code,
        method: 'GET',
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          window.location.href = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得下载链接失败');
        });
      // const res = await $verifyDownloadCode({ code: code });
      // if (res.data.code === 0) {
      //   window.location.href = 'https://eltmax-app.oss-cn-hangzhou.aliyuncs.com/EFLPhonics3rd.apk?versionId=null';
      // } else {
      //   this.$message.warning(res.data.message);
      // }
    }, 500),
  },
};
</script>

<style lang="less" scoped>
.downloadapp {
  height: 100%;
  width: 100%;
  .head {
    padding: 5vh 0 0 0;
    text-align: center;
    color: #ffffff;
    font-size: 8vw;
    letter-spacing: 20px;
  }
  .content {
    .left-photo {
      img {
        width: 8vw;
        height: 18vh;
      }
    }
    .english {
      padding: 0.8vh 5vw;
      margin: 3vh 0 0 17vw;
      display: block;
      height: 3vh;
      background: yellow;
      color: #0981b1;
      font-size: 80px;
      font-weight: 550;
    }
    .content-center {
      .center-head {
        position: relative;
        .img-left {
          position: absolute;
          top: -5vh;
          left: 10vw;
        }
        .img-right {
          position: absolute;
          top: -5vh;
          left: 50vw;
        }
        img {
          width: 25vw;
          height: 8vh;
        }
      }
      .center-box {
        margin: 0 auto;
        width: 90vw;
        height: 40vh;
        background: #ffffff !important;
        border-radius: 3vh;
        display: flex;
        justify-content: center;
        align-items: center;
        .soild-box {
          width: 84vw;
          height: 37vh;
          border: 20px dashed #00a8ec;
          border-radius: 3vh;
          .content-one {
            padding: 4vh;
            .small {
              background: #00a8ec;
              margin: 0 3vw;
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
            .big {
              background: #00a8ec;
              margin: 0 3vw;
              width: 60px;
              height: 60px;
              border-radius: 50%;
            }
            .el-button {
              width: 30vw;
              height: 5vh;
              background: #1375e7;
              color: #ffffff;
              border-radius: 4vh;
              font-size: 80px;
            }
          }
          .content-two {
            img {
              width: 250px;
              height: 250px;
            }
            span {
              margin-left: 2vw;
              font-size: 100px;
              color: #333333;
            }
          }
          .content-three {
            margin-top: 5vh;
            .btn {
              width: 60vw;
              height: 5vh;
              background: #9933cc;
              border-radius: 4vh;
              .white-circle {
                margin: 0.4vh 0 0 2vw;
                background: #ffffff;
                width: 120px;
                height: 120px;
                border-radius: 50%;
              }
              .content-text {
                margin-left: 10vw;
                color: #ffffff;
                font-size: 80px;
              }
            }
            img {
              width: 120px;
              height: 120px;
            }
          }
        }
      }
    }
  }
  .last-photo {
    position: relative;
    margin-top: 6vh;
    .img-one {
      position: absolute;
      left: 2vw;
      width: 28vw;
      height: 20vh;
    }
    .img-two {
      position: absolute;
      left: 24vw;
      width: 55vw;
      height: 20vh;
    }
    .img-three {
      position: absolute;
      left: 70vw;
      width: 28vw;
      height: 20vh;
    }
  }
}

.wxtip {
  background: url(../../assets/img/wx.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: none;
  position: fixed;
  left: 0;
  top: 0;
}
</style>
